import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import { SLUG } from 'lib/queries';
import { client } from 'lib/sanity';
import type { Slugs } from 'types/cms/Slugs';

export const PROMOTIONS_V2_KEY = 'promotionsV2';

export const fetchPromotionsV2 = async () => {
  const query = groq`
    *[ _type == 'timeline_promotionV2']{
      ${SLUG},
    }
  `;

  const promotions: Slugs = await client.fetch(query);
  return promotions;
};

export const usePromotionsV2 = () =>
  useQuery({ queryKey: [PROMOTIONS_V2_KEY], queryFn: fetchPromotionsV2 });
